import React from 'react';

const Commune = () => {
    return (
        <div>Commune</div>
    );
}

export default Commune;